export type LegalPageSlug =
  | 'terms-of-service'
  | 'privacy-policy'
  | 'cookie-policy'
  | 'data-processing-statement'
  | 'acceptable-use-policy'
  | 'platform-disclaimer'
  | 'payment-terms'
  | 'rfq-terms'
  | 'verified-status-terms'
  | 'golden-thread-disclaimer';

export interface LegalSection {
  heading?: string;
  paragraphs: string[];
}

export interface LegalPage {
  title: string;
  lastUpdated?: string;
  sections: LegalSection[];
}

export const LEGAL_PAGE_TRANSLATION_KEYS: Record<LegalPageSlug, string> = {
  'terms-of-service': 'legal.pages.termsOfService',
  'privacy-policy': 'legal.pages.privacyPolicy',
  'cookie-policy': 'legal.pages.cookiePolicy',
  'data-processing-statement': 'legal.pages.dataProcessingStatement',
  'acceptable-use-policy': 'legal.pages.acceptableUsePolicy',
  'platform-disclaimer': 'legal.pages.platformDisclaimer',
  'payment-terms': 'legal.pages.paymentTerms',
  'rfq-terms': 'legal.pages.rfqTerms',
  'verified-status-terms': 'legal.pages.verifiedStatusTerms',
  'golden-thread-disclaimer': 'legal.pages.goldenThreadDisclaimer',
};
